var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformationCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 11.785C2 6.38089 6.38089 2 11.785 2C17.1891 2 21.57 6.38089 21.57 11.785C21.57 17.1891 17.1891 21.57 11.785 21.57C6.38089 21.57 2 17.1891 2 11.785ZM11.79 15.52C11.3758 15.52 11.04 15.1843 11.04 14.77V11.67C11.04 11.2558 11.3758 10.92 11.79 10.92C12.2043 10.92 12.54 11.2558 12.54 11.67V14.79C12.5241 15.1942 12.1945 15.515 11.79 15.52ZM11.04 9.24998C11.04 9.66419 11.3758 9.99998 11.79 9.99998C12.1945 9.99497 12.5241 9.67411 12.54 9.26998V8.89998C12.54 8.48576 12.2043 8.14998 11.79 8.14998C11.3758 8.14998 11.04 8.48576 11.04 8.89998V9.24998Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationCircle);
export default __webpack_public_path__ + "static/media/InformationCircle.46dbbd5186cbb43a55f9f306d7ce60ec.svg";
export { ForwardRef as ReactComponent };